/** init domain config */
import Vue from 'vue'
//设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_BASE_URL
Vue.prototype.BASE_URL = process.env.BASE_URL
Vue.prototype.VUE_APP_PLATFORM_NAME = process.env.VUE_APP_PLATFORM_NAME
Vue.prototype.APP_KEY = process.env.VUE_APP_KEY
Vue.prototype.APP_SECRECT = process.env.VUE_APP_SECRECT
Vue.prototype.APP_ACCESS_TOKEN = process.env.VUE_APP_ACCESS_TOKEN
Vue.prototype.APP_TENANT_ID = process.env.VUE_APP_TENENT

window._CONFIG['domianURL'] = Vue.prototype.API_BASE_URL
window._CONFIG['baseURL'] = Vue.prototype.BASE_URL || ''
window._CONFIG['pdfDomainURL'] = Vue.prototype.API_BASE_URL+ '/sys/common/pdf/pdfPreviewIframe'

console.info('domainUrl='+window._CONFIG['domianURL']);
console.info('baseURL='+window._CONFIG['baseURL']);
console.info('-------------------------------------------------')
console.info(window._CONFIG['domianURL'])
if(window._CONFIG['domianURL'].startsWith("/")){
  window._CONFIG['domianURL'] = location.origin + window._CONFIG['domianURL'];
}

console.info('domainUrl='+window._CONFIG['domianURL']);
console.info('baseURL='+window._CONFIG['baseURL']);
console.info('-------------------------------------------------')